import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import api from '../lib/api';

const SaaSAuthContext = createContext(null);

export function SaaSAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const logoutRef = useRef(null);

  const logout = useCallback(async () => {
    try { await api.post('/saas/logout'); } catch {}
    setUser(false);
  }, []);
  logoutRef.current = logout;

  useEffect(() => {
    const interceptor = api.interceptors.response.use(
      r => r,
      err => {
        if (err?.response?.status === 401 && !err.config?.url?.includes('/saas/login') && !err.config?.url?.includes('/saas/me') && !err.config?.url?.includes('/saas/signup')) {
          logoutRef.current?.();
        }
        return Promise.reject(err);
      }
    );
    return () => api.interceptors.response.eject(interceptor);
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get('/saas/me');
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post('/saas/login', { email, password });
    setUser(data);
    return data;
  };

  const signup = async (name, email, password, companyName) => {
    const { data } = await api.post('/saas/signup', { name, email, password, company_name: companyName });
    if (!data?.needs_verification) {
      setUser(data);
    }
    return data;
  };

  return (
    <SaaSAuthContext.Provider value={{ user, loading, login, signup, logout, checkAuth }}>
      {children}
    </SaaSAuthContext.Provider>
  );
}

export function useSaaSAuth() {
  const ctx = useContext(SaaSAuthContext);
  if (!ctx) throw new Error('useSaaSAuth must be inside SaaSAuthProvider');
  return ctx;
}
